import { IpScope } from "./IpScope";
import { IpAddress, IpVersion } from "./IpAddress";
import { List } from "../Utils/List";
import { DeviceNameFilter } from "./DeviceFilter";

export class NetworkDiffSettings {
	public UseIpAddrsForIdentity: boolean;
	public IpAddrIncludeScope: IpScope;
	public IpAddrExcludeScope: IpScope;

	public UseHostNamesForIdentity: boolean;
	public HostNameIncludeScope: HostNameScope;
	public HostNameExcludeScope: HostNameScope;

    public UseDuplicateIdentityAttrs: boolean;
    public UseDuplicateMacs: boolean;

	constructor() {
		this.UseIpAddrsForIdentity = true;
		this.IpAddrIncludeScope = new IpScope();
		this.IpAddrExcludeScope = new IpScope();

		this.UseHostNamesForIdentity = true;
		this.HostNameIncludeScope = new HostNameScope();
		this.HostNameExcludeScope = new HostNameScope();

        //this.UseDuplicateIdentityAttrs = false;
        this.UseDuplicateIdentityAttrs = true;
        this.UseDuplicateMacs = false;
	}

	public UseIpAddrForIdentity(ip: IpAddress): boolean {
		
		if (!this.UseIpAddrsForIdentity)
			return false;

		if (!this.IpAddrIncludeScope.IsEmpty) {
			// The user specified include restrictions
			if (!this.IpAddrIncludeScope.Contains(ip))
				return false;
		}

		if (!this.IpAddrExcludeScope.IsEmpty) {
			// The user specified exclude restrictions
			if (this.IpAddrExcludeScope.Contains(ip))
				return false;
		}

		return true;
	}

	public UseHostNameForIdentity(hostName:string) :boolean {
		
		if (!this.UseHostNamesForIdentity)
			return false;

		if (!this.HostNameIncludeScope.IsEmpty) {
			// The user specified include restrictions
			if (!this.HostNameIncludeScope.Contains(hostName))
				return false;
		}

		if (!this.HostNameExcludeScope.IsEmpty) {
			// The user specified exclude restrictions
			if (this.HostNameExcludeScope.Contains(hostName))
				return false;
		}

		return true;
	}
}

export class HostNameScope {
	private _HostNamePatterns: List<string>;
	private _RegularExpressions: List<RegExp>;

	public get HostNamePatterns(): List<string>	{
		return this._HostNamePatterns;
	}

	constructor () {
		this._HostNamePatterns = new List<string>();
		this._RegularExpressions = new List<RegExp>();
	}

	public Clear() {
		this._HostNamePatterns.Clear();
		this._RegularExpressions.Clear();
	}

	public get IsEmpty(): boolean {
		return this._HostNamePatterns.Count == 0;
	}

	public AddHostNamePattern(pattern: string )	{
		this._HostNamePatterns.Add(pattern);
		this._RegularExpressions.Add(DeviceNameFilter.CreateRegex(pattern));
	}

	public Contains(hostName: string) : boolean {
		return this._RegularExpressions.Some((regex) => {
			if (regex.test(hostName))
				return true;
		});
	}
}
